/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Chinese (Traditional)
export default {
  'goal-actions.goal-content-about.edit-description-error-description': '發生錯誤，請在幾分鐘後再試一次。',
  'goal-content.goal-about-content.description-edit-button': '編輯',
  'goal-content.goal-about-content.description-title': '描述',
  'goal-content.goal-about-content.placeholder-description':
    '簡要描述為什麼這個目標很重要，以及如何衡量成功，以便您讓追蹤者獲得共識。',
  'goal-content.goal-content-about.edit-description-error-title': '無法編輯目標描述',
  'goal-content.goal-content-update-date.edited': '(已編輯)',
  'goal-content.goal-content-update-date.edited-tooltip': '編輯時間：{date}',
  'goal-content.goal-content-update-date.last-edited-by': '(上次編輯者：{name})',
  'goal-content.goal-content-updates.add-update': '新增更新',
  'goal-content.goal-content-updates.archived': '已封存',
  'goal-content.goal-content-updates.at-risk': '存在風險',
  'goal-content.goal-content-updates.cancelled': '已取消',
  'goal-content.goal-content-updates.completed': '已完成 🎉',
  'goal-content.goal-content-updates.date-changed': '已變更日期',
  'goal-content.goal-content-updates.edit-update': '編輯',
  "goal-content.goal-content-updates.for-date'": '{dueDate}',
  'goal-content.goal-content-updates.latest-update-title': '最近更新',
  'goal-content.goal-content-updates.missed-update-message': '沒有張貼任何更新',
  'goal-content.goal-content-updates.new-due-date': '新的截止日期',
  'goal-content.goal-content-updates.new-state': '新狀態',
  'goal-content.goal-content-updates.no-updates-description': '此目標尚未有更新內容。',
  'goal-content.goal-content-updates.off-track': '偏離正軌',
  'goal-content.goal-content-updates.old-due-date': '舊的截止日期',
  'goal-content.goal-content-updates.old-state': '舊狀態',
  'goal-content.goal-content-updates.on-track': '進度良好',
  'goal-content.goal-content-updates.paused': '已暫停',
  'goal-content.goal-content-updates.pending': '擱置中',
  'goal-content.goal-content-updates.previous-updates-title': '先前的更新',
  'goal-content.goal-content-updates.share-update': '分享',
  'goal-content.goal-content-updates.status-changed': '狀態已變更',
  'goal-content.goal-content-updates.write-update-button': '撰寫更新內容',
  'goal-content.goal-update-composer.modal-title': '張貼您的更新',
  'goal-content.goal-update-composer.post-button-label': '張貼更新',
};
